import React from "react";
import { Box } from "@mui/material";
import {
  MyTimesheetMyRequestsDashboardDateRangeNavigation,
  MyTimesheetMyRequestsDashboardDateRangePeriodIcons,
} from "my-timesheet/components";
import { PeriodType } from "my-timesheet/types/period-type";

interface MyRequestsDashboardDateRangeProps {
  currentDate: Date;
  onChangeCurrentDate: (date: Date) => void;
  period: PeriodType;
  onPeriodChange: (period: PeriodType) => void;
  isMobile: boolean;
}

export const MyTimesheetMyRequestsDashboardDateRange: React.FC<
  MyRequestsDashboardDateRangeProps
> = ({
  currentDate,
  onChangeCurrentDate,
  period,
  onPeriodChange,
  isMobile,
}) => {
  const iconSize = 24;

  return (
    <Box
      display="flex"
      flexDirection={isMobile ? "column-reverse" : "row"}
      alignItems={isMobile ? "flex-start" : "center"}
      width={isMobile ? "100%" : "auto"}
    >
      <MyTimesheetMyRequestsDashboardDateRangePeriodIcons
        isMobile={isMobile}
        iconSize={iconSize}
        period={period}
        onPeriodChange={onPeriodChange}
      />

      {isMobile && <Box height="16px" />}
      <MyTimesheetMyRequestsDashboardDateRangeNavigation
        iconSize={iconSize}
        isMobile={isMobile}
        currentDate={currentDate}
        period={period}
        onChangeCurrentDate={onChangeCurrentDate}
      />
    </Box>
  );
};

export default MyTimesheetMyRequestsDashboardDateRange;
